import React from "react";
import { FormAddAdCategory, FormAddCategory } from "./FormAddCategory";
import PanelHead from "../../Panel/PanelHead";
import PanelBody from "../../Panel/PanelBody";

export const PanelAddAdCategory = () => {
  return (
    <div>
      {" "}
      <PanelHead
        title={
          <div className="flex items-center justify-between w-full gap-4">
            <div>Add Ad category</div>
          </div>
        }
      />
      <PanelBody content={<FormAddAdCategory />} />
    </div>
  );
};
